import React from "react";
import { observer } from "mobx-react";
import { Group, Text } from "@mantine/core";
import { IconProps } from "@tabler/icons-react";
import { TextWithInfo } from "../modals/textWithInfo";

interface ShowBlockTimeRowProps {
  icon: React.ComponentType<IconProps>;
  label: string;
  blocktime: number; // Unix timestamp in seconds
  infoLink?: string;
}

const timeAgo = (timestamp: number) => {
  // Log the input timestamp
  console.log("Input timestamp:", timestamp);

  // Get the current time in seconds and log it
  const currentTimeInSeconds = Math.floor(Date.now() / 1000);
  console.log("Current time in seconds:", currentTimeInSeconds);

  // Calculate secondsAgo and log it
  const secondsAgo = currentTimeInSeconds - timestamp;
  console.log("Seconds ago:", secondsAgo);

  // Calculate minutes, hours, and days, and log each step
  const minutes = Math.floor(secondsAgo / 60);
  console.log("Minutes ago:", minutes);

  const hours = Math.floor(minutes / 60);
  console.log("Hours ago:", hours);

  const days = Math.floor(hours / 24);
  console.log("Days ago:", days);

  // Determine and return the appropriate time string
  if (days > 0) return `${days} days ago`;
  if (hours > 0) return `${hours} hours ago`;
  if (minutes > 0) return `${minutes} minutes ago`;
  return `${secondsAgo} seconds ago`;
};

const ShowBlockTimeRow: React.FC<ShowBlockTimeRowProps> = observer(
  ({ icon: Icon, label, blocktime, infoLink }) => {
    return (
      <tr>
        <td>
          <Group gap="xs">
            <Icon size="1rem" />
            <Text size="md">{label}</Text>
            {/* <TextWithInfo
              textSize="md"
              text={label}
              infoLink={infoLink || "https://docs.megalithic.me"}
            /> */}
          </Group>
        </td>
        <td>
          <Text>{timeAgo(blocktime)}</Text> {/* Time difference as a string */}
        </td>
      </tr>
    );
  }
);

export default ShowBlockTimeRow;
